import { API_CFG } from "@onmo/graphql";

const PROBE_TIMEOUT_MS = 5_000;
const MIN_DISPLAY_MS = 600;

const pickProbeUrl = (): string | undefined => {
  const api = (API_CFG as { api?: Record<string, string | undefined> })?.api;
  return (
    api?.httpApolloUrl ||
    api?.legacyHttpApolloUrl ||
    api?.primaryLegacyHttpApolloUrl
  );
};

const runProbe = async (): Promise<boolean> => {
  const url = pickProbeUrl();
  if (!url) return true;

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), PROBE_TIMEOUT_MS);

  try {
    await fetch(url, {
      method: "HEAD",
      mode: "no-cors",
      cache: "no-store",
      signal: controller.signal,
    });
    return true;
  } catch (e) {
    if (e instanceof Error && e.name === "AbortError") return true;
    return false;
  } finally {
    clearTimeout(timer);
  }
};

export const probeNetwork = async (): Promise<boolean> => {
  const [result] = await Promise.all([
    runProbe(),
    // wait MIN_DISPLAY_MS(ms)
    new Promise<void>((r) => setTimeout(r, MIN_DISPLAY_MS)),
  ]);
  return result;
};
